module.exports = __webpack_public_path__ + "static/media/decoracion_abajo.30c9a79d.svg";